var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-icon" }, [
    _vm.fileType === "pdf"
      ? _c("div", [_c("fa", { attrs: { icon: "file-pdf" } })], 1)
      : _vm.fileType === "doc" || _vm.fileType === "docx"
      ? _c("div", [_c("fa", { attrs: { icon: "file-word" } })], 1)
      : _vm.fileType === "xls" ||
        _vm.fileType === "xlsx" ||
        _vm.fileType === "csv" ||
        _vm.fileType === "xlsm"
      ? _c("div", [_c("fa", { attrs: { icon: "file-excel" } })], 1)
      : _vm.fileType === "png" ||
        _vm.fileType === "bmp" ||
        _vm.fileType === "jpeg" ||
        _vm.fileType === "jpg"
      ? _c("div", [_c("fa", { attrs: { icon: "file-image" } })], 1)
      : _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "currentColor",
              viewBox: "0 0 24 24",
              stroke: "none",
            },
          },
          [_c("circle", { attrs: { cx: "12", cy: "12", r: "10" } })]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }